import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <div className="app-footer" style={{ borderTop: "1px solid var(--border-secondary)", padding: "16px 20px", display: "flex", justifyContent: "space-between", alignItems: "center", fontSize: "12px", color: "var(--text-dim)" }}>
      <span>
        Made with ♥ by{" "}
        <a href="mailto:heowuayngon@gmail.com" style={{ color: "var(--text-muted)", textDecoration: "none", borderBottom: "1px solid var(--border-primary)" }}>
          heowuayngon
        </a>
      </span>
      <Link to="/app/feedback" style={{ color: "var(--text-muted)", textDecoration: "none", borderBottom: "1px solid var(--border-primary)", fontSize: "12px" }}>
        💬 Đóng góp ý kiến
      </Link>
    </div>
  );
}
